<template>
    <div
        class="page-wrap"
        v-loading="loading"
        element-loading-text="Please wait. This might take a while depending on the size and amount of your attachments."
    >
        <div style="width: 100%">
            <el-row :gutter="15">
                <el-col>
                    <h2 v-if="currentStep < 5">Hello{{ currentUserName }}!</h2>
                    <h2 v-else>Thank you!</h2>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        v-model="formData[steps[0]]"
                        :step="currentStep"
                        v-if="currentStep == 0"
                        step-title="Contact details of the person applying"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[1]]"
                        v-if="currentStep == 1"
                        :applicant="formData.applicant"
                        step-title="Billing Address"
                    ></FormStep>
                    <PaymentStep
                        :step="currentStep"
                        v-model="formData[steps[2]]"
                        v-if="currentStep == 2"
                        :billing="formData.billing"
                        @gosubmit="handleSubmitForm"
                    ></PaymentStep>
                    <ThankyouStep
                        :step="currentStep"
                        v-if="currentStep == 3"
                        :paymethod="formData.payment.method"
                        :form-id="submittedFormId"
                    ></ThankyouStep>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import FormStep from "./FormStep";
import PaymentStep from "./PaymentStep";
import ThankyouStep from "./ThankyouStep";
import formApi from "../api";

export default {
    components: {
        FormStep,
        PaymentStep,
        ThankyouStep,
    },
    methods: {
        handleSubmitForm() {
            let self = this;
            if (self.submittedFormId) {
                self.processPayment();
            } else {
                this.loading = true;
                formApi
                    .save(this.formData, this.formType)
                    .then(function (response) {
                        if (response && response.data && response.data.id) {
                            self.submittedFormId = response.data.id;
                            self.processPayment();
                        } else {
                            alert(
                                "Unfortunately, we could not save the form. Please try again."
                            );
                        }
                    })
                    .catch(function (error) {
                        alert(
                            "Oops, it appears that something went wrong! Please try again!"
                        );
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        processPayment() {
            if (this.formData.payment.method == "bank") {
                this.currentStep += 1;
            } else {
                this.pay();
            }
        },
        async pay() {
            let self = this;
            self.loading = true;
            self.paymentAttempt += 1;
            function showResult(result) {
                document.getElementsByClassName(
                    "app"
                )[0].innerHTML = `<pre>${JSON.stringify(
                    result,
                    null,
                    2
                )}</pre>`;
            }
            async function handleAllInOne(token) {
                //console.log("token in function : ", token);
                const sdk = new window.Elavon3DSWebSDK({
                    baseUrl: "https://gw.fraud.elavon.com/3ds2",
                    token: token,
                });

                var dat =
                    self.formData.payment.cardyear[2] +
                    self.formData.payment.cardyear[3] +
                    self.formData.payment.cardmonth;
                //console.log(window.test_amount);
                const test_amt = 100;
                //console.log(test_amt);
                const response = await sdk
                    .web3dsFlow({
                        messageId: "MSG_" + self.formData.formId,
                        purchaseAmount: test_amt,
                        acctNumber: self.formData.payment.cardnumber.replace(
                            /\D/g,
                            ""
                        ),
                        cardExpiryDate: dat,
                        purchaseCurrency: "840",
                        purchaseExponent: "2",
                        messageCategory: "01",
                        transType: "01",
                        threeDSRequestorAuthenticationInd: "01",
                        challengeIframeElement:
                            document.getElementById("holder"),
                        clientStartProtocolVersion: "2.1.0",
                        clientEndProtocolVersion: "2.2.0",
                    })
                    .then(async (response) => {
                        const threedsData = {
                            directoryServerTransactionId: response.acsTransID,
                            transactionStatus: response.transStatus,
                            electronicCommerceIndicator: response.eci,
                            authenticationValue: response.eci,
                            protocolVersion: response.messageVersion,
                        };
                        await formApi
                            .getPaymentToken(self.submittedFormId, threedsData)
                            .then(function (response) {
                                if (
                                    response &&
                                    response.data.type == "success"
                                ) {
                                    self.loading = false;
                                    callbacks.onApproval(response.data);
                                } else {
                                    self.loading = true;
                                    callbacks.onDeclined(response.data.message);
                                }
                            });
                    })
                    .catch((e) => {
                        console.error(e);
                        showResult(e);
                    });
                return response;
            }
            let callbacks = {
                onError: function (error) {
                    alert(
                        "Oops, our payment gateway could not process your card. Please try again, or choose another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttemptEu(
                        self.submittedFormId,
                        "error",
                        error
                    );
                },
                onDeclined: function (response) {
                    alert(
                        "Unfortunately, your card was not accepted. Please check with your issuer bank if there is any problem, try with another card, or try another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttemptEu(
                        self.submittedFormId,
                        "declined",
                        JSON.stringify(response)
                    );
                },
                onApproval: function (response) {
                    formApi
                        .savePaymentAttemptEu(
                            self.submittedFormId,
                            "approved",
                            JSON.stringify(response)
                        )
                        .then(function (response) {})
                        .catch(function (error) {})
                        .then(() => {
                            self.currentStep += 1;
                            self.loading = false;
                        });
                },
            };
            formApi
                .getAuthenticationToken()
                //.getPaymentToken(self.submittedFormId)
                .then(function (response) {
                    const token = JSON.parse(response["data"]["token"]);
                    handleAllInOne(token.token);
                })
                .catch(function (error) {
                    self.loading = false;
                    alert(
                        "Oops, it appears that something went wrong! Please try again, or choose another payment method."
                    );
                });
        },
    },
    data: () => ({
        loading: false,
        currentStep: 0,
        submittedFormId: "",
        paymentAttempt: 0,
        formType: "testaward",
        steps: ["applicant", "billing", "payment", "thankyou"],
        title: window.config.appName,
        formData: {
            applicant: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                applying_as: null,
                newsletter: null,
            },
            billing: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                vat_id: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            payment: {
                method: "card",
                cardnumber: null,
                cardmonth: null,
                cardyear: null,
                cvv: null,
            },
        },
    }),
};
</script>
